var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'folder-open']}}),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('empty_message')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }